import { api } from '../../core/services';

export const getOne = async (id, callback) =>
  api.get(`/api/products/${id}`, null, callback);

export const removeBackground = async (productId, model, callback) =>
  api.post(`/api/products/${productId}/bg-remove`, { model }, callback);

export default {
  getOne,
  removeBackground,
};
